export enum ComparisonOperatorEnum {
    EqualTo = 0,
    GreaterThan = 1,
    LessThan = 2,
    GreaterThanOrEqualTo = 3,
    LessThanOrEqualTo = 4,
}

export function comparisonOperatorEnumLabel(value: ComparisonOperatorEnum): string {
    switch (value) {
        case ComparisonOperatorEnum.EqualTo:
            return "enum.comparisonOperator.equalTo";
        case ComparisonOperatorEnum.GreaterThan:
            return "enum.comparisonOperator.greaterThan";
        case ComparisonOperatorEnum.LessThan:
            return "enum.comparisonOperator.lessThan";
        case ComparisonOperatorEnum.GreaterThanOrEqualTo:
            return "enum.comparisonOperator.greaterThanOrEqualTo";
        case ComparisonOperatorEnum.LessThanOrEqualTo:
            return "enum.comparisonOperator.lessThanOrEqualTo";
        default:
            return "common.unknown";
    }
}
